export const defaultVars = {
    "--primary-black": "#111111",
    "--sale-price": "#c32a01",
    "--primary-green": "#476d46",
    "--primary-darkgreen": "#324c31",
    "--primary-lightgray": "#f2f3ec",
    "--secondary-green": "#6f866e",
    "--secondary-lightgray": "#afb0b3",
    "--speechbubble-background": "#476d46",
    "--speechbubble-text": "#ffffff",
    "--font-default": "aktiv-grotesk, sans-serif",
    "--font-brand": "united-sans, sans-serif",
    "--text-transform": "uppercase"
};

export const nordrumVars = {
    "--primary-black": "#111111",
    "--sale-price": "#a70000",
    "--primary-green": "#65b32e",
    "--primary-darkgreen": "#405d3e",
    "--primary-lightgray": "#faf9f8",
    "--secondary-green": "#74c33b",
    "--secondary-lightgray": "#d8d4c4",
    "--speechbubble-background": "#d8d4c4",
    "--speechbubble-text": "#111111",
    "--font-default": "poppins, sans-serif",
    "--font-brand": "poppins, sans-serif",
    "--text-transform": "none"
};